if (!customElements.get('ss-newsletter-signup')) {
  customElements.define('ss-newsletter-signup', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form || this.onSubmit) return;
      this.onSubmit = this.submit.bind(this);
      // Own this submission before the generic Shopify contact-form listener.
      this.form.addEventListener('submit', this.onSubmit, true);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.onSubmit = null;
    }

    async submit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.submitting || !this.form.reportValidity()) return;

      const button = this.form.querySelector('button[type="submit"]');
      const feedback = this.form.querySelector('[data-newsletter-feedback]');
      const fields = new FormData(this.form);
      this.submitting = true;
      button.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      feedback.hidden = true;

      try {
        // Match the welcome popup's list-mode contact submission.
        const contact = {
          email: fields.get('contact[email]').trim(),
          signup_source: fields.get('signup_source'),
          lists: { [this.dataset.listId]: true },
          popup_id: Number(this.dataset.popupId),
        };
        const identity = document.cookie.split('; ').find((cookie) => cookie.startsWith('fls_id='));
        if (identity) contact.flsid = identity.slice('fls_id='.length);

        let requestTimeout;
        let result;
        try {
          result = await Promise.race([
            // The SDK also awaits tracking after signup. Use the contact
            // response itself so a tracking failure cannot undo success.
            fetch('https://api.flashy.app/thunder/contact?overwrite=true&channel=false&primary_key=email', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ contact, account_id: Number(this.dataset.accountId) }),
            }).then((response) => {
              if (!response.ok) throw new Error('Newsletter signup rejected');
              return response.json();
            }),
            new Promise((resolve, reject) => {
              requestTimeout = setTimeout(() => reject(new Error('Signup confirmation timed out')), 20000);
            }),
          ]);
        } finally {
          clearTimeout(requestTimeout);
        }
        if (!result?.success) throw new Error('Newsletter signup rejected');

        this.form.reset();
        feedback.textContent = feedback.dataset.successMessage;
        feedback.classList.add('ss-home-newsletter__message--success');
      } catch (error) {
        feedback.textContent = error?.message === 'Signup confirmation timed out'
          ? feedback.dataset.timeoutMessage
          : feedback.dataset.errorMessage;
        feedback.classList.remove('ss-home-newsletter__message--success');
      } finally {
        this.submitting = false;
        button.disabled = false;
        this.form.removeAttribute('aria-busy');
        feedback.hidden = false;
        feedback.focus();
      }
    }
  });
}
